(function () {
    function pad(n) { return String(n).padStart(2, '0'); }

    function init() {
        var bar = document.querySelector('.announcement-bar');
        if (!bar) return;
        var deadline = Date.parse(bar.getAttribute('data-deadline'));
        var before = document.getElementById('announcement-before');
        var after = document.getElementById('announcement-after');
        var timer = document.getElementById('countdown');

        // Test-only override: ?countdown_now=2027-01-22T00:00:00Z simulates "now" (ticks forward from there).
        var offset = 0;
        var override = Date.parse(new URLSearchParams(window.location.search).get('countdown_now'));
        if (!isNaN(override)) offset = override - Date.now();

        var interval;
        function update() {
            var distance = deadline - (Date.now() + offset);
            // Class on <html> so [data-valentine-cutoff-line] stays hidden after cart drawer AJAX re-renders.
            document.documentElement.classList.toggle('countdown-expired', !isNaN(deadline) && distance <= 0);
            if (isNaN(deadline) || distance <= 0) {
                timer.hidden = true;
                if (!isNaN(deadline)) { before.hidden = true; after.hidden = false; }
                clearInterval(interval);
                return;
            }
            before.hidden = false;
            after.hidden = true;
            timer.hidden = false;
            document.getElementById('days').textContent = pad(Math.floor(distance / 86400000));
            document.getElementById('hours').textContent = pad(Math.floor((distance % 86400000) / 3600000));
            document.getElementById('minutes').textContent = pad(Math.floor((distance % 3600000) / 60000));
            document.getElementById('seconds').textContent = pad(Math.floor((distance % 60000) / 1000));
        }
        update();
        interval = setInterval(update, 1000);
    }

    // The script tag follows the bar markup, so run now (before later content paints, no flash);
    // fall back to DOMContentLoaded if the bar is not parsed yet.
    if (document.querySelector('.announcement-bar')) init();
    else document.addEventListener('DOMContentLoaded', init);
})();
